export default "__VITE_ASSET___WiTKVn1__"